import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  input: {
    width: '100%', // Garantir que os campos ocupem 100% do espaço dentro do Grid
    marginBottom: theme.spacing(2), // Espaçamento entre os campos
  },
  inputAlert: {
    width: '100%',
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ff9800', // Cor laranja para o alerta
        borderWidth: '2px',
      },
      '&:hover fieldset': {
        borderColor: '#f57c00', // Laranja mais escuro no hover
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ef6c00', // Laranja ainda mais escuro quando focado
      },
    },
    '& .MuiInputLabel-root': {
      color: '#f57c00', // Cor do label
      '&.Mui-focused': {
        color: '#ef6c00',
      },
    },
  },
  formControl: {
    width: '100%', // Certificar que os campos Select também tenham 100% de largura do contêiner
  },
  gridItem: {
    // Limitar o tamanho de cada campo para 25% da tela
    width: '25%',  // 25% da largura da tela
    [theme.breakpoints.down('sm')]: {
      width: '100%', // Em telas pequenas (como celulares), os campos ocupam 100% da largura
    },
  },
}));